/**
 * Reaktionen + Bilder in Direktnachrichten (Marcel 22.10.2026, „wie bei WhatsApp“) – 1:1-Port von
 * dartcloud-backend/src/core/helper/chat-media-rules.js (PURE). Parität: src/fixtures/chat-reactions.json.
 */
export const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];
export const MAX_IMAGES_PER_MESSAGE = 4;

export interface ChatReaction { userId?: string | null; emoji?: string | null; at?: number | null }
export interface ReactionSummary { emoji: string; count: number; mine: boolean; userIds: string[] }

const str = (v: unknown): string => (v == null ? '' : String(v).trim());

/** Vorschau für Chatliste: Text, sonst „📷 Foto“ / „📷 3 Fotos“. */
export function previewText(content: unknown, imageCount = 0, maxLength = 100): string {
  const text = str(content);
  if (text) return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  const n = Number(imageCount) || 0;
  if (n <= 0) return '';
  return n === 1 ? '📷 Foto' : `📷 ${n} Fotos`;
}

/** Zusammenfassung je Emoji: Zähler, „mine“, Reihenfolge nach Zähler (dann erste Nennung). */
export function summarizeReactions(reactions: ChatReaction[] | null | undefined, viewerId: string | null = null): ReactionSummary[] {
  const list = (Array.isArray(reactions) ? reactions : []).filter((r) => r && r.userId && r.emoji);
  const order: string[] = [];
  const map = new Map<string, ReactionSummary>();
  for (const r of list) {
    const emoji = String(r.emoji);
    if (!map.has(emoji)) { map.set(emoji, { emoji, count: 0, mine: false, userIds: [] }); order.push(emoji); }
    const e = map.get(emoji)!;
    e.count += 1;
    e.userIds.push(String(r.userId));
    if (viewerId != null && String(r.userId) === String(viewerId)) e.mine = true;
  }
  return order.map((k) => map.get(k)!).sort((a, b) => b.count - a.count || order.indexOf(a.emoji) - order.indexOf(b.emoji));
}

/** Reaktion lokal umschalten (optimistisch, PURE wie im Backend): gleiche weg, andere ersetzt. */
export function toggleReaction(reactions: ChatReaction[] | null | undefined, userId: string, emoji: string, now = Date.now()): { reactions: ChatReaction[]; action: 'added' | 'removed' | 'changed' } {
  const list = (Array.isArray(reactions) ? reactions : []).filter((r) => r && r.userId && r.emoji);
  const mine = list.find((r) => String(r.userId) === String(userId));
  const rest = list.filter((r) => String(r.userId) !== String(userId));
  if (mine && mine.emoji === emoji) return { reactions: rest, action: 'removed' };
  return { reactions: [...rest, { userId: String(userId), emoji, at: now }], action: mine ? 'changed' : 'added' };
}
